import { Controller } from "@hotwired/stimulus";
import QrScanner from "qr-scanner";

const SCANNING_KEY = "checkInScanning";

// Scans ticket QR codes with the device camera and looks each one up on the check-in page.
// The camera restarts after each family, so the door keeps scanning without extra taps.
export default class extends Controller {
  static targets = ["video", "error", "startButton", "stopButton"];
  static values = { lookupUrl: String };

  connect() {
    if (sessionStorage.getItem(SCANNING_KEY)) this.start();
  }

  disconnect() {
    this.scanner?.destroy();
    this.scanner = null;
  }

  async start() {
    this.errorTarget.hidden = true;
    this.scanner ||= new QrScanner(this.videoTarget, (result) => this.found(result.data), {
      returnDetailedScanResult: true,
      highlightScanRegion: true,
    });
    try {
      await this.scanner.start();
      sessionStorage.setItem(SCANNING_KEY, "1");
      this.showCamera(true);
    } catch (error) {
      sessionStorage.removeItem(SCANNING_KEY);
      this.showError("The camera could not be opened. Allow camera access, or type the ticket code below.");
    }
  }

  stop() {
    sessionStorage.removeItem(SCANNING_KEY);
    this.scanner?.stop();
    this.showCamera(false);
  }

  found(text) {
    const code = this.ticketCode(text);
    if (!code) {
      this.showError("That QR code is not an event ticket.");
      return;
    }
    this.scanner.stop();
    const url = new URL(this.lookupUrlValue, window.location.origin);
    url.searchParams.set("code", code);
    window.Turbo.visit(url.toString());
  }

  // Tickets hold a /tickets/<code> URL; a bare code is accepted too.
  ticketCode(text) {
    const value = text.trim();
    const fromUrl = value.match(/\/tickets\/([0-9A-Za-z-]+)\/?$/);
    if (fromUrl) return fromUrl[1];
    return /^[0-9A-Za-z-]{8,9}$/.test(value) ? value : null;
  }

  showCamera(on) {
    this.videoTarget.hidden = !on;
    this.startButtonTarget.hidden = on;
    this.stopButtonTarget.hidden = !on;
  }

  showError(message) {
    this.errorTarget.textContent = message;
    this.errorTarget.hidden = false;
  }
}
